<template>
  <div v-if="showPop" class="same_question_guide">
    <VanOverlay :show="showPop" z-index="999" lock-scroll @click="this.close">
      <div>
        <div class="question_white">
          <p>根据题目，纸上作答</p>
          <img
            src="https://img01.yzcdn.cn/upload_files/2021/09/14/FsGqMo1rlpUk23qF0OwVjJTOdrro.png"
          />
        </div>
        <div v-mask class="bottom_white">
          <p class="text1">解析：点击解析查看题目答案和讲解</p>
          <img
            class="img1"
            src="https://img01.yzcdn.cn/upload_files/2021/09/14/FnLCzYM6uhxM0czRO_OmZlya-JNT.png"
          />
          <p class="text2">加错题：做错的题目记得加错题本</p>
          <img
            class="img2"
            src="https://img01.yzcdn.cn/upload_files/2021/09/14/FmgipNmNIpsl_pd5Rqd4Ts9uYssb.png"
          />
        </div>
      </div>
    </VanOverlay>
  </div>
</template>

<script>
/*
 * By Suxue
 * 2021/9/13
 */
import popRegister from '@/mixins/popRegister'
import { mapState } from 'vuex'
import { updateTreasureBox } from '@/api/user'
import { Overlay } from 'vant'

export default {
  name: 'SameQuestionGuide',
  components: {
    VanOverlay: Overlay
  },
  mixins: [popRegister],
  data() {
    return {
      popupName: 'SameQuestionGuide',
      keyName: 'SQIndex',
      showPop: false,
      resetElementTopLayer: null
    }
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  mounted() {},
  methods: {
    openAction() {
      const {
        userInfo: { treasureBox },
        keyName
      } = this
      const hasOpen = String(treasureBox).includes(keyName)
      if (hasOpen) {
        this.dealClose()
        return
      }
      // 返回页面顶部，以防止定位错误
      window.scrollTo(0, 0)
      this.showPop = true
      // 置顶锚点元素
      document.querySelector('.same_question .bottom_fixed').style.position = 'absolute'
      document.querySelector('.same_question .bottom_icons').style.cssText =
        'position: relative; z-index: 99999'
    },
    closeAction() {
      this.showPop = false
      document.querySelector('.same_question .bottom_fixed').style.position = 'fixed'
      document.querySelector('.same_question .bottom_icons').style.cssText =
        'position: static; z-index: 0'
      updateTreasureBox({
        keyName: this.keyName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.same_question_guide {
  .question_white {
    position: absolute;
    top: 60px;
    padding: 0 10px;
    p {
      font-size: 16px;
      color: #ffffff;
    }
    img {
      width: 100%;
    }
  }
  .bottom_white {
    position: absolute;
    width: 90px;
    height: 50px;
    bottom: 6px;
    left: 10px;
    background: #ffffff;
    border-radius: 5px;
    .text1 {
      position: absolute;
      top: -90px;
      left: 30px;
      white-space: nowrap;
      font-size: 16px;
      color: #ffffff;
    }
    .img1 {
      position: absolute;
      top: -60px;
      left: 10px;
      width: 15px;
    }
    .text2 {
      position: absolute;
      top: -60px;
      left: 40px;
      white-space: nowrap;
      font-size: 16px;
      color: #ffffff;
    }
    .img2 {
      position: absolute;
      top: -35px;
      left: 55px;
      width: 11px;
    }
  }
}
.nav_links_wrap_guide {
  position: absolute;
  width: 181px;
  height: 188px;
  left: 8px;
  top: 49px;
  background: #ffffff;
  border-radius: 28px 28px 10px 28px;
}
.nav_links_text_guide {
  position: absolute;
  top: 250px;
  left: 23px;
  font-size: 16px;
  white-space: nowrap;
  color: #ffffff;
}
.icon_wrap_guide {
  width: 360px;
  height: 97.25px;
  background: #ffffff;
  top: 238px;
  border-radius: 17px;
}
.icon_wrap_guide_shou {
  top: 350px;
}
.icon_wrap_guide_img {
  width: 60px;
}
.icon_wrap_guide_text {
  white-space: nowrap;
  margin-top: 12px;
  font-size: 16px;
  color: #ffffff;
}
.answer_guide_but {
  width: 110px;
  margin-top: 12px;
}
</style>
